export const IndicatorTypes = {
    HoverBoxIndicatorType: 'hover-box',
    highlightBoxIndicatorType: 'highlight-box-2',
    HaloIndicatorType: 'halo',
    FocusBoxIndicatorType: 'focus-box',
    ContainerBoxIndicatorType: 'container-box',
    BreadcrumbsIndicatorType: 'breadcrumbs',
    EditBoxIndicatorType: 'edit-box',
    FocusModeIndicatorType: 'focus-mode-indicator',
    HoverBoxMasterPieceIndicatorType: 'master-piece-hover-box',
    TextEditorIndicatorType: 'TEXT_EDITOR_GLOBAL_INDICATION',
    AttachCandidateIndicatorType: 'attach-candidate',
    BorderHaloIndicatorType: 'border-halo',
    DragHandleIndicatorType: 'drag-handle',
    GridDockingIndicatorType: 'grid-docking',
    MarginsIndicatorType: 'margins-indicator',
    PaddingIndicatorType: 'container-padding',
    GridBubbleIndicatorType: 'grid-docking-bubble',
    GridSectionAddIndicatorType: 'grid-section-add',
    GridRulersIndicatorType: 'grid-rulers',
    GridLinesIndicatorType: 'grid-lines',
    RotationIndicatorType: 'rotation',
    DropZoneIndicatorType: 'drop-zone',
    BlankSectionIndicatorType: 'blank-section',
    InfoMessageIndicatorType: 'info-message',
};
export const IndicatorGroups = {
    PageLayout: 'page-layout-indicators',
    Grid: 'grid-indicators',
    Masters: 'masters-indicator',
    GFPP: 'GFPP-indicators',
    Sizing: 'sizing-indicators',
    Drag: 'drag-indicators',
};
//# sourceMappingURL=indicatorTypes.js.map